import * as React from "react";
import { ListSection, List, ListItem } from "../../elements/list";
export class DishIngredientsList extends React.Component {
    render() {
        const { ingredients } = this.props;
        // const totalUnchecked = ingredients.reduce((total, i) => total + (i.active ? 0 : 1), 0);
        // if (totalUnchecked === 0) return null;
        return (React.createElement("div", null,
            React.createElement(ListSection, { className: "text-sm" },
                React.createElement("div", { className: "font-semibold" }, "Remove Ingredients"),
                React.createElement(List, { className: "" }, ingredients.map(({ ingredient }, i) => {
                    return (React.createElement(ListItem, { key: i, className: "r-list-item" }, ingredient.name));
                })))));
    }
}
//# sourceMappingURL=dish-ingredients-list.js.map